import React from 'react'

const Settings: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-text-primary">Settings</h1>
        <p className="text-text-muted mt-1">Configure your DarkSentinel settings</p>
      </div>

      <div className="bg-background-secondary border border-zinc-700 rounded-lg p-6">
        <p className="text-text-muted text-center py-12">
          Settings page coming soon...
        </p>
      </div>
    </div>
  )
}

export default Settings
